if (!customElements.get('lp-free-shipping-progress')) {
  customElements.define('lp-free-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10);
      this.fillEl = this.querySelector('.lp-fs-progress__fill');
      this.textEl = this.querySelector('.lp-fs-progress__text');
      this.fetchAndRender();
      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
          // product-form.js publishes the /cart/add response (line-item object, no total_price)
          // cart.js and cart-drawer.js publish the full cart object (has total_price)
          // Fall back to fetchAndRender() when total_price is missing
          if (e.cartData?.total_price !== undefined) {
            this.render(e.cartData.total_price);
          } else {
            this.fetchAndRender();
          }
        });
      }
    }
    disconnectedCallback() {
      if (this.unsub) this.unsub();
    }
    async fetchAndRender() {
      try {
        const r = await fetch('/cart.js');
        if (!r.ok) return;
        const c = await r.json();
        this.render(c.total_price);
      } catch (e) {
        console.error('[lp-free-shipping-progress] fetch failed:', e);
      }
    }
    render(totalCents) {
      const pct = Math.min(100, (totalCents / this.threshold) * 100);
      this.fillEl.style.width = pct + '%';
      if (totalCents >= this.threshold) {
        this.textEl.textContent = this.dataset.unlockedText;
      } else {
        const remaining = this.threshold - totalCents;
        const fmt = window.Shopify.formatMoney(remaining, this.dataset.moneyFormat);
        this.textEl.textContent = this.dataset.remainingPattern.replace('{amount}', fmt);
      }
    }
  });
}
